module.exports = __webpack_public_path__ + "img/icon_right.b2e2526f.png";